const bannerUtils = {
  toImage: (src: string, href = null) => ({
    src,
    href,
    type: 'image',
  }),
};

export const en = {
  entry: {
    to_exhibition_hall: 'Enter Exhibition Hall',
    how_to_use_oms: '<b>How to utilize</b><b>virtual expo?</b>',
    next_show: 'Space Booking for Next Show',
  },
  banners: {
    left: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/fb32e97b-8118-4623-be86-b9424a575504.jpg',
      ),
    ],
    right: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/ab4b6a2e-b29e-4bc3-9665-23bad9030775.jpg',
      ),
    ],
    middle: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/43e1a787-96bf-4269-bce4-107a9d9525e9.jpg',
        'https://www.jpfood.jp/en-gb.html',
      ),
    ],
    mobile: [],
  },
};

en.banners.mobile = [
  ...en.banners.middle,
  ...en.banners.left,
  ...en.banners.right,
];

export const ja = {
  entry: {
    to_exhibition_hall: '展示会場はこちら',
    how_to_use_oms: '<b>はじめに</b><i>オンライン来場・商談サービスの使い方</i>',
    next_show: '次年度 出展に興味のある方',
  },
  banners: {
    left: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/470aa77f-fdaa-4c6b-a167-4d0bf483a137.jpg',
      ),
    ],
    right: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/0b1aaa76-5a73-4ff5-81ab-b99a08372812.jpg',
      ),
    ],
    middle: [
      bannerUtils.toImage(
        'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/a854bdfd-434f-48f9-bafc-f7c317eb4543.jpg',
        'https://www.jpfood.jp/ja-jp.html',
      ),
    ],
    mobile: [],
  },
};

ja.banners.mobile = [
  ...ja.banners.middle,
  ...ja.banners.left,
  ...ja.banners.right,
];

export const zhHans = {
  entry: {
    to_exhibition_hall: '展览会场',
    how_to_use_oms: '<b>在线观展・商谈指南</b>',
    next_show: '下届展会参展咨询',
  },
};

export const zhHant = {
  entry: {
    to_exhibition_hall: '展覽會場',
    how_to_use_oms: '<b>線上觀展/商談服務</b><b>使用方式</b>',
    next_show: '預定下屆參展攤位',
  },
};
